import { __ } from "@wordpress/i18n";
import { PanelColorSettings } from "@wordpress/block-editor";
import {
  PanelBody,
  __experimentalBorderControl as BorderControl,
  __experimentalUnitControl as UnitControl,
} from "@wordpress/components";
import ShadowPicker from "../../../../../../Externals/Src/Gutenberg/CustomBoxShadow/ShadowComponent";
import "./style.scss";

export default function StylesPopup({ attributes, setAttributes }) {
  const { popupStyles = {} } = attributes;

  const updatePopup = (patch) =>
    setAttributes({ popupStyles: { ...popupStyles, ...patch } });

  const handleBorderChange = (newBorder) => {
    updatePopup({
      borderWidth: newBorder?.width || "1px",
      borderColor: newBorder?.color || "#e2e8f0",
      borderStyle: newBorder?.style || "solid",
    });
  };

  return (
    <PanelBody title={__("Popup Styles", "brandy-blocks")} initialOpen={false}>
      <div className="brandy-share-settings">
        <PanelColorSettings
          title={__("Colors", "brandy-blocks")}
          initialOpen={false}
          colorSettings={[
            {
              value: popupStyles.background || "#ffffff",
              onChange: (val) => updatePopup({ background: val }),
              label: __("Background", "brandy-blocks"),
            },
            {
              value: popupStyles.textColor || "#374151",
              onChange: (val) => updatePopup({ textColor: val }),
              label: __("Text Color", "brandy-blocks"),
            },
            {
              value: popupStyles.hoverBackground || "#f9fafb",
              onChange: (val) => updatePopup({ hoverBackground: val }),
              label: __("Hover Background", "brandy-blocks"),
            },
            {
              value: popupStyles.hoverTextColor || "#111827",
              onChange: (val) => updatePopup({ hoverTextColor: val }),
              label: __("Hover Text Color", "brandy-blocks"),
            },
          ]}
        />
      </div>

      <div className="brandy-share-settings">
        <UnitControl
          label={__("Border Radius", "brandy-blocks")}
          value={popupStyles.borderRadius || "12px"}
          onChange={(val) => updatePopup({ borderRadius: val })}
          units={[
            { value: "px", label: "px", default: 12 },
            { value: "%", label: "%", default: 50 },
          ]}
        />
      </div>

      <div className="brandy-share-settings">
        <BorderControl
          label={__("Border", "brandy-blocks")}
          onChange={handleBorderChange}
          value={{
            width: popupStyles.borderWidth || "1px",
            color: popupStyles.borderColor || "#e2e8f0",
            style: popupStyles.borderStyle || "solid",
          }}
          withSlider={true}
          colors={[]}
          enableStyle={true}
          className="brandy-border-control"
        />
      </div>

      <div className="brandy-share-settings">
        <ShadowPicker
          label={__("Box Shadow", "brandy-blocks")}
          shadow={popupStyles.shadow}
          onChange={(val) => updatePopup({ shadow: val })}
        />
      </div>

      <div className="brandy-share-settings">
        <UnitControl
          label={__("Item Padding", "brandy-blocks")}
          help={__("Top and bottom padding of each item. Left/right is fixed at 20px.", "brandy-blocks")}
          value={popupStyles.itemPadding || "12px"}
          onChange={(val) => updatePopup({ itemPadding: val })}
          units={[{ value: "px", label: "px", default: 12 }]}
        />
      </div>
    </PanelBody>
  );
}
